import { contactData } from '@/mocks/homeData';

export default function ContactSection() {
  return (
    <section id="contact" className="py-16 md:py-20 bg-background-100">
      <div className="max-w-[720px] mx-auto px-4 md:px-6 text-center">
        <span className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full bg-secondary-100 text-secondary-700 text-xs font-medium mb-4">
          <i className="ri-mail-send-line"></i>
          期待你的声音
        </span>
        <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-3">
          {contactData.title}
        </h2>
        <p className="text-sm text-foreground-500 mb-3">
          {contactData.subtitle}
        </p>
        <p className="text-sm text-foreground-400 leading-relaxed mb-8">
          {contactData.description}
        </p>
        <a
          href={`mailto:${contactData.email}`}
          className="inline-flex items-center gap-2 px-8 py-3 bg-primary-500 hover:bg-primary-600 text-background-50 font-medium rounded-full transition-colors cursor-pointer whitespace-nowrap text-sm no-underline"
        >
          <i className="ri-mail-line"></i>
          {contactData.email}
        </a>
      </div>
    </section>
  );
}